//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Gateway.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/SelectNXObjectList.js";
import "../no/Expression.js";
import "../no/SelectObjectList.js";
let d=[[[1,"Area",0,"Expression",0],[0,"AreaStatus",1,0],[0,"AssignmentStatus",1,0],[1,"Density",0,"Expression",0],[0,"DensityStatus",1,0],[0,"DeriveOption",1,1],[0,"GravityCenterStatus",1,0],[1,"GravityCenterX",0,"Expression",0],[1,"GravityCenterY",0,"Expression",0],[1,"GravityCenterZ",0,"Expression",0],[0,"InertiaStatus",1,0],[1,"Mass",0,"Expression",0],[0,"MassStatus",1,0],[0,"MassType",1,0],[1,"MomentsInertiaXX",0,"Expression",0],[1,"MomentsInertiaYY",0,"Expression",0],[1,"MomentsInertiaZZ",0,"Expression",0],[1,"Objects",0,"SelectNXObjectList",0],[1,"ProductsInertiaXY",0,"Expression",0],[1,"ProductsInertiaXZ",0,"Expression",0],[1,"ProductsInertiaYZ",0,"Expression",0],[0,"ValueType",1,0],[1,"Volume",0,"Expression",0],[0,"VolumeStatus",1,0]],[[[],"GetAssignmentValues",{},0,0]],[]];
SPLM.Gateway.MassAssignmentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Gateway.MassAssignmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Gateway.MassAssignmentBuilder.ValueTypes = Object.freeze({
    "Asserted" : "Asserted", "Actual" : "Actual", "UserDefined1" : "UserDefined1", "UserDefined2" : "UserDefined2", "UserDefined3" : "UserDefined3", "UserDefined4" : "UserDefined4", "Estimated" : "Estimated", "Budget" : "Budget"});

SPLM.Gateway.MassAssignmentBuilder.MassTypes = Object.freeze({
    "MassOnly" : "MassOnly", "DensityMass" : "DensityMass", "DensityVolume" : "DensityVolume", "MassVolume" : "MassVolume"});

export default SPLM;